import { AUTH_URL } from "../constants/authDrawer";
import backend from "./backend";
import {
  getSecondsIn,
  removeCookieParams,
  setCookieParams,
} from "utils/cookies";
import { Cookies } from "react-cookie";
import { COOKIES } from "config/constants";

export const eventFilter = (event, expectedSource) => {
  try {
    return (
      event &&
      event.origin === window.location.origin &&
      event.isTrusted &&
      event.source &&
      "name" in event.source &&
      event.source.name === expectedSource &&
      event.data &&
      "authToken" in event.data &&
      event.data.authToken
    );
  } catch (e) {
    return false;
  }
};

// Refresh token by opening up invisible iFrame
export const refreshToken = () => {
  // The token will be refreshed, so there's no reason to keep it anymore.
  const cookies = new Cookies();
  cookies.remove(COOKIES.AUTH_TOKEN, removeCookieParams());
  const framePromise = new Promise(resolve => {
    const iframe = document.createElement("iframe");

    iframe.src = AUTH_URL;
    iframe.width = 0;
    iframe.height = 0;
    iframe.style.border = "none";
    iframe.name = "reauthorization iframe";

    document.body.appendChild(iframe);

    window.addEventListener("message", event => {
      if (eventFilter(event, iframe.name)) {
        resolve(event.data.authToken);
        iframe.remove();
      }
    });
  });

  const timeoutPromise = new Promise((resolve, reject) => {
    const timeoutId = window.setTimeout(() => {
      window.clearTimeout(timeoutId);
      reject();
    }, 5000);
  });

  return Promise.race([framePromise, timeoutPromise]);
};

export const updateAxiosToken = token => {
  let authToken;
  const cookies = new Cookies();
  if (token) {
    authToken = token;

    cookies.set(COOKIES.AUTH_TOKEN, authToken, {
      ...setCookieParams(),
      maxAge: getSecondsIn({ days: 31 }),
    });
  } else {
    const cookies = new Cookies();
    authToken = cookies.get(COOKIES.AUTH_TOKEN);
  }

  // Update Axios instance to send headers after auth
  backend.defaults.headers.common = {
    ...backend.defaults.headers.common,
    Authorization: `Bearer ${authToken}`,
  };
};
